import { Panel, TOKENS } from '../ui/dashboard-primitives'
import { Md } from './Md'

/**
 * The next milestone, as the analysis phrased it. No progress bar: the callout
 * is free text, so inventing a percentage would be fiction (decision D-D-style).
 */
export function MilestoneBar({ callout }: { callout: string }) {
  if (!callout) return null
  return (
    <Panel variant="light" className="grid grid-cols-1 md:grid-cols-[12rem_1fr] gap-x-10 gap-y-3 items-start">
      <span
        className="text-[0.5625rem] tracking-[0.28em] uppercase pt-1.5"
        style={{ fontFamily: 'var(--font-mono)', color: TOKENS.creamDim }}
      >
        Next milestone
      </span>
      <p className="text-[1.125rem] leading-[1.55]" style={{ color: TOKENS.creamSoft, maxWidth: '52ch' }}>
        <Md>{callout}</Md>
      </p>
    </Panel>
  )
}
